import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const TrainingDetailIndexRevamp = () => {
  const { navigation } = useNavigation()
  const { id } = useParams()

  return (
    <>
      <Navigate
        replace
        to={navigation.trainings.list.details_revamp.view.overview.fullPath({ id: Number(id) })}
      />
    </>
  )
}

export default TrainingDetailIndexRevamp
